import React, { Ref, forwardRef } from 'react';

import { IconButton, InputAdornment } from '@mui/material';
import { BaseTextFieldProps } from '@mui/material/TextField/TextField';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import clsx from 'clsx';

import AppTextField from '../../designe/textfields/app-text-field/AppTextField';
import { useStyles } from './Search.styles';

interface IAppSearchProps extends BaseTextFieldProps {
  onChange?: (value: any) => void;
  mode?: 'light' | 'dark';
  InputProps?: any;
}

const Search = forwardRef(
  (props: IAppSearchProps, ref?: Ref<HTMLDivElement>) => {
    const { onChange, className, value, mode, ...otherProps } = props;
    const { classes } = useStyles({ mode: mode || 'dark' });

    return (
      <AppTextField
        {...otherProps}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={clsx(classes.searchInput, className)}
        classes={{ root: classes.searchInputRoot }}
        ref={ref}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon classes={{ root: 'search-icon' }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => onChange('')}
                edge="end"
                size="small">
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    );
  },
);

export default Search;
